import React from 'react';
import { Link } from 'react-router-dom';

const KIND_LABELS = { update: '새 기능', notice: '공지' };

const toPath = (url) => {
  try {
    const parsed = new URL(url, window.location.origin);
    return `${parsed.pathname}${parsed.search}`;
  } catch (_) {
    return '/help';
  }
};

const NewsWhatquizNews = ({ items }) => {
  if (!items?.length) return null;
  return (
    <section className="news-section" aria-labelledby="news-whatquiz-title">
      <h2 id="news-whatquiz-title" className="news-section-title">왓퀴즈 소식</h2>
      <div className="news-wq-list">
        {items.map((item) => (
          <Link key={item.id} to={toPath(item.url)} className="news-wq-card">
            {item.image?.src ? (
              <img className="news-wq-image" src={item.image.src} alt={item.image.alt || ''} loading="lazy" />
            ) : (
              <div className="news-wq-image news-wq-image--empty" aria-hidden="true">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M3 11v2a1 1 0 0 0 1 1h2l5 4V6L6 10H4a1 1 0 0 0-1 1z" />
                  <path d="M15.5 8.5a5 5 0 0 1 0 7" />
                  <path d="M18.5 5.5a9 9 0 0 1 0 13" />
                </svg>
              </div>
            )}
            <div className="news-wq-body">
              <span className={`news-chip ${item.important ? 'news-chip--strong' : ''}`}>
                {KIND_LABELS[item.kind] || '소식'}
              </span>
              <strong className="news-wq-title">{item.title}</strong>
              {item.summary && <p className="news-wq-summary">{item.summary}</p>}
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default NewsWhatquizNews;
